import { render } from "./MergeCustomers.vue?vue&type=template&id=3523e566"
import script from "./MergeCustomers.vue?vue&type=script&lang=js"
export * from "./MergeCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__